/** @name: lnk-form 单独使用的form表单，只有表单元素，可以实现配置校验默认值，值列表多单选下拉，普通input输入框，多文本输入框，时间选择器，开关/默认按钮，picklist与mvg
* @createdby:Wangyue
*
* @props:
* :data:Object,弹框中列表的数据
* :disbled:Boolean，整体控制表单只读
* 列：itemData: [
*    {
*        name: '固定电话', // 表单行前方的名称
*        lnkType: 'input', // 表单行的类型，默认为input
*        field: 'tel', // 表单行所接收数据的属性名
*        placeholder: '请输入您的固定电话', // 输入框内的提示文字
*        disabled: true, // 控制表单行的只读
*        // 表单的验证规则
*        rule: {
*            required: false, // 是否必填
*            message: '', // 必填时的提示语
*            ruleType: ['tel'], // 基本验证规则类型，[电话(checkTel)手机(checkIphone)邮箱(checkEmail)] |此处可以自定义复杂规则，可以看lnk-form-rule.js 文件，了解详细内容|
*            custom: [] // 自定义规则，写法与elementUI的规则写法保持一致即可
*        }
*    },
*    {
*        name: '手机号码', // 表单行前方的名称
*        lnkType: 'input', // 表单行的类型，默认为input
*        field: 'phone', // 表单行所接收数据的属性名
*        placeholder: '请输入您的手机号码', // 输入框内的提示文字
*        disabled: true, // 控制表单行的只读
*        // 表单的验证规则
*        rule: {
*            required: true, // 是否必填
*            message: '请输入手机号码', // 必填时的提示语
*            ruleType: ['phone'], // 基本验证规则类型，[电话(checkTel)手机(checkIphone)邮箱(checkEmail)]
*            custom: [] // 自定义规则，写法与elementUI的规则写法保持一致即可
*        }
*    },
*    {
*        name: '电子邮件', // 表单行前方的名称
*        lnkType: 'input', // 表单行的类型，默认为input
*        field: 'email', // 表单行所接收数据的属性名
*        placeholder: '请输入您的邮箱', // 输入框内的提示文字
*        disabled: true, // 控制表单行的只读
*        // 表单的验证规则
*        rule: {
*            required: false, // 是否必填
*            message: '', // 必填时的提示语
*            ruleType: ['email'], // 基本验证规则类型，[电话(checkTel)手机(checkIphone)邮箱(checkEmail)]
*            custom: [] // 自定义规则，写法与elementUI的规则写法保持一致即可
*        }
*    },
*    {
*        name: '活动名称', // 表单行前方的名称
*        lnkType: 'input', // 表单行的类型，默认为input
*        field: 'name', // 表单行所接收数据的属性名
*        placeholder: '请输入活动名称', // 输入框内的提示文字
*        disabled: true, // 控制表单行的只读
*        // 表单的验证规则
*        rule: {
*            required: true, // 是否必填
*            message: '请输入活动名称', // 必填时的提示语
*            ruleType: '', // 基本验证规则类型，[电话(Tel)手机(Iphone)邮箱(Email)]
*            custom: [{min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur'}] // 自定义规则，写法与elementUI的规则写法保持一致即可
*        }
*    },
*    {
*        name: '下拉菜单',
*        lnkType: 'combobox',
*        field: 'selectionValue',
*        lov: 'SERVICE_STATUS', // 值列表的类型（必填）
*        parentLovType: '', // 父值列表的类型
*        parentLovValue: '', // 父值列表的显示值
*        disabled: true, // 控制表单行的只读
*        custom: [], // 自定义下拉内容
*        // 表单的验证规则
*        rule: {
*            required: true, // 是否必填
*            message: '请选择内容', // 必填时的提示语
*            ruleType: '', // 基本验证规则类型，[电话(Tel)手机(Iphone)邮箱(Email)]
*            custom: [] // 自定义规则，写法与elementUI的规则写法保持一致即可
*        }
*    },
*   {
*        name: '地区三级联动',
*        lnkType: 'address',
*        field: 'addressValue',
*        disabled: true, // 控制表单行的只读
*        // 表单的验证规则
*        rule: {
*            required: true, // 是否必填
*            message: '请选择内容', // 必填时的提示语
*            ruleType: '', // 基本验证规则类型，[电话(Tel)手机(Iphone)邮箱(Email)]
*            custom: [] // 自定义规则，写法与elementUI的规则写法保持一致即可
*        }
*    },
*    {
*        name: '多选框',
*        lnkType: 'multiselect',
*        field: 'checkboxValue',
*        lov: 'USER_STATUS', // 值列表的类型（必填）
*        parentLovType: '', // 父值列表的类型
*        parentLovValue: '', // 父值列表的显示值
*        disabled: true, // 控制表单行的只读
*        // custom: [{name: '曲奇', value: 'cookie'}, {name: '红色', value: 'red'}], // 自定义多选内容，注意这里自定义后，需要在接收数据对象中，把对应的属性内容定义为数组类型
*        // 表单的验证规则
*        rule: {
*            required: true, // 是否必填
*            message: '请选择内容', // 必填时的提示语
*            ruleType: '', // 基本验证规则类型，[电话(Tel)手机(Iphone)邮箱(Email)]
*            custom: [] // 自定义规则，写法与elementUI的规则写法保持一致即可
*        }
*    },
*    {
*        name: '单选框',
*        lnkType: 'radio',
*        field: 'radioValue',
*        lov: 'ACCT_STAGE', // 值列表的类型（必填）
*        parentLovType: 'ACCT_TYPE', // 父值列表的类型
*        parentLovValue: 'Consumer', // 父值列表的显示值
*        disabled: true, // 控制表单行的只读
*        custom: [{name: '曲奇', value: 'cookie'}, {name: '红色', value: 'red'}], // 自定义单选内容
*        // 表单的验证规则
*        rule: {
*            required: true, // 是否必填
*            message: '请选择内容', // 必填时的提示语
*            ruleType: '', // 基本验证规则类型，[电话(Tel)手机(Iphone)邮箱(Email)]
*            custom: [] // 自定义规则，写法与elementUI的规则写法保持一致即可
*        }
*    },
*    {
*        name: '文本输入框',
*        lnkType: 'textarea',
*        field: 'textareaValue',
*        disabled: true, // 控制表单行的只读
*        // 表单的验证规则
*        rule: {
*            required: true, // 是否必填
*            message: '请选择内容', // 必填时的提示语
*            ruleType: '', // 基本验证规则类型，[电话(Tel)手机(Iphone)邮箱(Email)]
*            custom: [] // 自定义规则，写法与elementUI的规则写法保持一致即可
*        }
*    },
*    {
*        name: '联动日期',
*        lnkType: 'daterange',
*        field: 'daterangeValue',
*        startPlaceholder: '开始日期', // 设定开始日期框内的提示文字
*        endPlaceholder: '结束日期', // 设定结束日期框内的提示文字
*        valueFormat: 'yyyy-MM-dd', // 设定获取值的格式类型，和elementUI的规则相同
*        format: 'yyyy-MM-dd', // 设定显示值的格式类型，和elementUI的规则相同
*        disabled: true, // 控制表单行的只读
*        // 表单的验证规则
*        rule: {
*            required: true, // 是否必填
*            message: '请选择内容', // 必填时的提示语
*            ruleType: '', // 基本验证规则类型，[电话(Tel)手机(Iphone)邮箱(Email)]
*            custom: [] // 自定义规则，写法与elementUI的规则写法保持一致即可
*        }
*    },
*    {
*        name: '单选日期',
*        lnkType: 'date',
*        field: 'daterValue',
*        placeholder: '请选择日期啊', // 设定框内的提示文字
*        valueFormat: 'yyyy-MM-dd', // 设定获取值的格式类型，和elementUI的规则相同
*        format: 'yyyy-MM-dd', // 设定显示值的格式类型，和elementUI的规则相同
*        disabled: true, // 控制表单行的只读
*        // 表单的验证规则
*        rule: {
*            required: true, // 是否必填
*            message: '请选择内容', // 必填时的提示语
*            ruleType: '', // 基本验证规则类型，[电话(Tel)手机(Iphone)邮箱(Email)]
*            custom: [] // 自定义规则，写法与elementUI的规则写法保持一致即可
*        }
*    },
*    {
*        name: '开关',
*        lnkType: 'switch',
*        field: 'switchValue',
*        activeColor: 'red', // 设定开启时（true）的开关颜色
*        inactiveColor: 'black', // 设定关闭时（false）的开关颜色
*        disabled: true // 控制表单行的只读
*    },
*    {
*        name: '是否选中',
*        lnkType: 'checkbox',
*        field: 'checkedValue',
*        trueLabel: 'Y', // 设定选中时按钮所显示的值
*        falseLabel: 'N', // 设定非选中时按钮所显示的值
*        disabled: true // 控制表单行的只读
*    },
*    {
*        name: 'pickList',
*        lnkType: 'picklist',
*        field: 'acctName', // pickList的field为你列表里的需要值得属性名，比如acctName或者postName等，为显性数据
*        disabled: true, // 控制表单行的只读
*        mainField: 'acctName', // 设定展示的属性名称
*        pickMap: {id: 'acctId'}, // 设定返回值的格式{"acctId":"W-5F7LN"}，为所需要的隐形数据
*        change(val){console.log(val)}, // 回调函数，当picklist选中，改变时调用，参数val指的是当前选中的详细数据
*        remote: appCtx.cdnPath+'/linkcrm/picklist/account.json' // 远程配置信息，若下方fields有值将被覆盖（详情看picklist组件配置）
*        gridOptions: {
*            multiSelect: false, // 是否多选
*            title: '选择经销商', // picklist标题
*            url: appCtx.ctxPath + '/action/link/accnt/queryByExamplePage', // 请求数据url
*            defaultNoQuery: false, // 默认不查询，展开窗口后需要手动点击查询才会查询数据
*            fields: [
*                {
*                    field: 'acctCode', // 字段名称
*                    name: '客户编码', // 显示名称
*                    minWidth: 120
*                },
*                {
*                    field: 'acctName', // 字段名称
*                    name: '客户名称', // 显示名称
*                    defaultSearch: true, // 默认查询此列
*                    minWidth: 180
*                },
*                {
*                    field: 'gender',
*                    name: '性别',
*                    lov: 'GENDER', // 值列表类型
*                    sortable: false // 是否可排序
*                },
*                {
*                    field: 'mobilePhone1',
*                    name: '手机号',
*                    minWidth: 120
*                },
*                {
*                    field: 'address',
*                    name: '地址',
*                    showOverflowTooltip: true// 超长值时以提示框形式浮动显示
*                },
*                {
*                    field: 'created',
*                    name: '创建时间',
*                    minWidth: 140, // 列最小宽度
*                    lnkType: 'date', // 列类型-目前只支持date
*                    mark: 'date' // 日期到后台是日期格式or字符串格式（string)
*                }
*            ],
*            params: { // 设置默认查询条件
*                filtersRaw: [
*                    {
*                        id: 'acctType',
*                        property: 'acctType',
*                        value: 'Dealer', // 经销商
*                        operator: '='
*                    }
*                ]// 设置默认filtersRaw
*                // acctName:'王老板', //也可以设置具体接口可接受的参数
*            }
*        }
*    },
*    {
*        name: 'MVG',
*        lnkType: 'mvg',
*        field: 'postnName', // 所需显性数据值
*        disabled: true, // 控制表单行的只读
*        mainField: 'postnName', // 设定展示的属性名称
*        pickMap: {id: 'postnId'}, // 所需隐形数据值
*        mvgTitle: '客户职位MVG Demo',  // mvg标题
*        mvgName: 'accntPostn', // mvg的名字
*        mvgParentId: 'W-30D4CE2', // mvg的id，这个值需要询问后台，不同的mvg有不同的id（详情请看mvg组件配置文档）
*        change(value){console.log(value);}, // 回调函数，当picklist选中，改变时调用，参数val指的是当前选中的详细数据
remote: appCtx.cdnPath+'/linkcrm/mvg/accnt_postn.json', // 远程配置信息，若下方leftTableOptions/rightTableOptions有值将被覆盖（详情看mvg组件配置）
*        gridOptions: {
*            mvgParentId: 'W-30D4CE2', // mvg主表记录id
*            title: '客户职位MVG Demo',
*            leftTableOptions: {
*                // 左侧列表配置
*                fields: [ // 显示列的配置
*                    {
*                        field: 'id', // 字段名称
*                        name: '职位id'// 显示名称
*                    },
*                    {
*                        field: 'postnName', // 字段名称
*                        name: '职位名称', // 显示名称
*                        defaultSearch: true, // 默认查询此列
*                        showOverflowTooltip: true
*                    }
*                ],
*                params: {
*                    // postnName:'商旅行业顾问07', //可以指定额外的查询条件 --此demo中的该查询条件不生效的，还要后端接口支持才行
*                }
*            },
*            rightTableOptions: {
*                // 右侧列表配置，若不明确指定，则使用左侧列表的列配置信息
*                // 右侧列表不支持queryParams
*                fields: [ // 显示列的配置
*                    {
*                        field: 'id', // 字段名称
*                        name: '职位id'// 显示名称
*                    },
*                    {
*                        field: 'postnName', // 字段名称
*                        name: '职位名称', // 显示名称
*                        defaultSearch: true, // 默认查询此列
*                        showOverflowTooltip: true
*                    }
*                ]
*            }
*        }
*    }
*    ],
*    formData: {
*               switchValue: true,  // 设置默认值
*               checkedValue: 'Y'  //设置默认值
*           },
*
* @hooks:
*
* @example:
* html:
*
<lnk-form ref="lnkFormCom" :form-item="itemData" :form-data="formData" width="500px"></lnk-form>
*
<el-button size="mini" type="primary" @click="getChecked">提交</el-button>
*
<el-button size="mini" @click="">重置</el-button>
* js:
*     ……
*      data:{
*          exportDialog:false,
*          dataArr:{}
*                 ……
*      }
*      ……
*      // 检测是否校验完成
*      getChecked(){
*          const check = this.$refs.lnkFormCom.setChecked(); // 通过这段代码，给你的组件设定一个ref的名字，然后调用组件中的setChecked的方法，此方法会return一个布尔值，true为验证成功，false为验证不全成功。
*          if(check){
*              alert('submit success');
*          }else{
*              alert('submit error');
*          }
*      },
*/


<template>
    <div class="lnk-form-dialog" :style="getWidth">
        <el-form :model="lnkFormData" :rules="getRules" label-position="right" ref="lnkform">
            <el-row>
                <el-col :key="index" :span="getRow" v-for="(item,index) in formItem"
                        style="display: inline-block;float: none;">
                    <el-form-item :label="item.name" :prop="item.field">
                        <!--输入框-->
                        <el-input v-if="item.lnkType === 'input' || item.lnkType === undefined || item.lnkType === ''"
                                  v-model="lnkFormData[item.field]" :placeholder="item.placeholder"
                                  :disabled="disabled || item.disabled"></el-input>
                        <!--下拉菜单-->
                        <lnk-lov v-if="item.lnkType === 'combobox' && (!item.custom || item.custom.length === 0)"
                                 v-model="lnkFormData[item.field]" :lov="item.lov" :parent-lov-type="item.parentLovType"
                                 :parent-lov-value="item.parentLovValue" @setlovvalue="setSelectionLovValue"
                                 :disabled="disabled || item.disabled"></lnk-lov>
                        <el-select v-if="item.lnkType === 'combobox' && (item.custom && item.custom.length > 0)"
                                   v-model="lnkFormData[item.field]" placeholder="请选择"
                                   :disabled="disabled || item.disabled">
                            <el-option
                                :key="sindex"
                                v-for="(cus,sindex) in item.custom"
                                :label="cus.name"
                                :value="cus.value">
                            </el-option>
                        </el-select>
                        <!--单选-->
                        <lnk-lov-radio v-if="item.lnkType === 'radio' && (!item.custom || item.custom.length === 0)"
                                       v-model="lnkFormData[item.field]" :lov="item.lov"
                                       :parent-lov-type="item.parentLovType" :parent-lov-value="item.parentLovValue"
                                       @setlovvalue="setRadioLovValue"
                                       :disabled="disabled || item.disabled"></lnk-lov-radio>
                        <el-radio-group v-if="item.lnkType === 'radio' && (item.custom && item.custom.length > 0)"
                                        v-model="lnkFormData[item.field]" :disabled="disabled || item.disabled">
                            <el-radio :key="sindex" v-for="(cus,sindex) in item.custom" :label="cus.value">
                                {{cus.name}}
                            </el-radio>
                        </el-radio-group>
                        <!--三级地址选择-->
                        <lnk-address-cascader v-if="item.lnkType === 'address'" v-model="lnkFormData"
                                              :prop-mapping="['province','city','district']" classname="innerbox"
                                              :disabled="disabled || item.disabled"
                                              @change="addressChange"></lnk-address-cascader>
                        <!--多选-->
                        <lnk-lov-check
                            v-if="item.lnkType === 'multiselect' && (!item.custom || item.custom.length === 0)"
                            v-model="lnkFormData[item.field]" :lov="item.lov" :parent-lov-type="item.parentLovType"
                            :parent-lov-value="item.parentLovValue" @setlovvalue="setCheckboxLovValue"
                            :disabled="disabled || item.disabled"></lnk-lov-check>
                        <el-checkbox-group
                            v-if="item.lnkType === 'multiselect' && (item.custom && item.custom.length > 0)"
                            v-model="lnkFormData[item.field]" :disabled="disabled || item.disabled">
                            <el-checkbox :key="sIndex" v-for="(cus,sIndex) in item.custom" :label="cus.value">
                                {{cus.name}}
                            </el-checkbox>
                        </el-checkbox-group>
                        <!--文本输入框-->
                        <el-input v-if="item.lnkType === 'textarea'" v-model="lnkFormData[item.field]" type="textarea"
                                  row="4" :disabled="disabled || item.disabled"></el-input>
                        <!--关联日期选择-->
                        <lnk-daterange-picker
                            v-if="item.lnkType === 'daterange'"
                            :disabled="disabled || item.disabled"
                            classname="innerbox"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            :start.sync="lnkFormData[item.field]"
                            :end.sync="lnkFormData[item.fieldend]"
                            type="daterange">
                        </lnk-daterange-picker>
                        <!--单个日期选择-->
                        <el-date-picker v-if="item.lnkType === 'date'" v-model="lnkFormData[item.field]" type="date"
                                        :placeholder="item.placeholder" :format="item.format"
                                        :value-format="item.valueFormat"
                                        :disabled="disabled || item.disabled"></el-date-picker>
                        <!--开关按钮-->
                        <el-switch v-if="item.lnkType === 'switch'" v-model="lnkFormData[item.field]"
                                   :active-color="item.activeColor" :inactive-color="item.inactiveColor"
                                   :disabled="disabled || item.disabled"></el-switch>
                        <!--是否选中-->
                        <el-checkbox v-if="item.lnkType === 'checkbox'" v-model="lnkFormData[item.field]"
                                     :true-label="item.trueLabel" :false-label="item.falseLabel"
                                     :disabled="disabled || item.disabled"></el-checkbox>
                        <!--picklist-->
                        <lnk-picklist v-if="item.lnkType === 'picklist'"
                                      :disabled="disabled || item.disabled"
                                      :grid-options="item.gridOptions"
                                      v-model="lnkFormData[item.field]"
                                      picklist-type="input"
                                      :main-field="item.mainField"
                                      :pick-object.sync="lnkFormData"
                                      :pick-map="item.pickMap"
                                      :remote="item.remote"
                                      @change="item.change"></lnk-picklist>
                        <!--mvg-->
                        <lnk-mvg v-if="item.lnkType === 'mvg'"
                                 :disabled="disabled || item.disabled"
                                 v-model="lnkFormData[item.field]"
                                 mvg-type="input"
                                 :pick-map="item.pickMap"
                                 :pick-object.sync="lnkFormData"
                                 :main-field="item.mainField"
                                 :title="item.mvgTitle"
                                 :mvg-name="item.mvgName"
                                 :mvg-parent-id="item.mvgParentId"
                                 :left-table-options="item.gridOptions.leftTableOptions"
                                 :right-table-options="item.gridOptions.rightTableOptions"
                                 :remote="item.remote"
                                 @mvg-change="item.change"></lnk-mvg>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>

<script>
    import lnkAddressCascader from '../lnk-address-cascader';
    import {lnkLov, lnkLovRadio, lnkLovCheck} from '../lnk-lov';
    import lnkPicklist from '../lnk-picklist';
    import lnkMvg from '../lnk-mvg';
    import formRules from './rules';

    export default {
        name: 'lnk-form',

        components: {lnkAddressCascader, lnkLovRadio, lnkLovCheck, lnkLov, lnkPicklist, lnkMvg},

        data: function () {
            return {
                lnkFormData: linkTools.deepCopy(this.formData), // form表单数据存储值
            };
        },

        /** 组件与外界数据交流。*/
        props: {
            // 接收组件外传递进来的，配置form表单元素的对象
            formItem: {
                type: [Object, Array],
                required: true
            },
            // 接收组件外传递进来的，组件内form表单数据存储值
            formData: {
                type: Object,
                required: true
            },
            // 接收组件外传递进来的，设定组件的宽度的值
            width: {
                type: String,
                default: '100%'
            },
            // 接收组件外传递的列数，控制表单的列数
            row: {
                type: [Number, String],
                default: 1
            },
            // 接收组件外部传递的布尔值，控制表单整体的只读
            disabled: {
                type: Boolean,
                default: false
            }
        },
        watch: {
            formData: {
                handler: function (val) {
                    for (let key in val) {
                        this.$set(this.lnkFormData, key, val[key]);
                    }
                },
                deep: true
            },
            lnkFormData: {
                handler: function (val) {
                    for (let key in val) {
                        this.$set(this.formData, key, val[key]);
                    }
                },
                deep: true
            },
        },

        /** 初始页面调用。*/
        mounted: function () {
            this.$nextTick(function () {
                // console.log(this.getRules);
                // console.info(this.disabled);
            });
        },

        /** 计算属性。*/
        computed: {
            // 获得从组件外部传来的宽度，设定组件的宽度
            getWidth() {
                return 'width:' + this.width + ';';
            },
            // 设定表单列数
            getRow() {
                return 24 / this.row;
            },
            // 获取组件外部的配置，配置form表单组件中每个表单元素的校验规则
            getRules() {
                const arr = {};
                for (let i = 0; i < this.formItem.length; i++) {
                    const item = this.formItem[i];
                    if (item.rule) {
                        if (item.rule.required === true) {
                            if (item.lnkType === 'input' && item.lnkType === undefined) {
                                arr[item.field] = [{required: true, message: item.rule.message, trigger: 'blur'}];
                            } else {
                                arr[item.field] = [{required: true, message: item.rule.message, trigger: 'change'}];
                            }
                        } else {
                            arr[item.field] = [];
                        }
                        if (item.rule.ruleType && item.rule.ruleType.length !== 0) {
                            for (let j = 0; j < item.rule.ruleType.length; j++) {
                                for (const key in formRules) {
                                    if (item.rule.ruleType[j] === key) {
                                        const obj = {
                                            validator: formRules[key],
                                            trigger: 'blur'
                                        };
                                        arr[item.field].push(obj);
                                    }
                                }
                            }
                        }
                        if (item.rule.custom && item.rule.custom.length !== 0) {
                            arr[item.field] = arr[item.field].concat(item.rule.custom);
                        }
                    }
                }
                return arr;
            }
        },

        /** 方法模块。*/
        methods: {
            // 对下拉菜单组件的回调函数，名字固定
            setSelectionLovValue(val) {
                // console.info(val);
            },
            // 对单选组件的回调函数，名字固定
            setRadioLovValue(val) {
                // console.info(val);
            },
            // 对多选组件的回调函数，名字固定
            setCheckboxLovValue(val) {
                // console.info(val);
            },
            // 地址组件的回调函数，名字固定
            addressChange(val) {
                console.log(val);
            },
            // 给外部返回是否验证通过
            setChecked() {
                let flag = false;
                this.$refs.lnkform.validate((valid) => {
                    flag = valid;
                });
                return flag;
            },
            /**
             *@createdBy 常九福
             *@date 2019/1/21
             *@methods:clearValidate
             *@description:清除验证
             **/
            clearValidateForm() {
                this.$refs.lnkform.clearValidate();
            }
        }
    };
</script>

<style>
    /*.lnk-form-dialog{*/
    /*float: left;*/
    /*}*/
    /*form表单，输入框和文本框的样式调整*/
    .lnk-form-dialog .el-input__inner {
        width: 280px;
        height: 28px;
        font-size: 12px;
    }

    .lnk-form-dialog .el-textarea__inner {
        width: 280px;
        font-size: 12px;
        -webkit-border-radius: 0;
        -moz-border-radius: 0;
        border-radius: 0;
    }

    /*弹框内的form表单，联动时间样式调整*/
    .lnk-form-dialog .el-date-editor .el-range__icon {
        line-height: 0;
    }

    .lnk-form-dialog .el-date-editor .el-range-input {
        font-size: 12px;
    }

    .lnk-form-dialog .el-date-editor .el-range-separator {
        line-height: 18px;
    }

    .lnk-form-dialog .el-date-editor.el-input, .lnk-form-dialog .el-date-editor.el-input__inner {
        width: 280px;
    }

    .lnk-form-dialog .el-input__icon {
        line-height: 0;
    }

    /*弹框内的form表单，多选/单选样式调整*/
    .lnk-form-dialog .el-checkbox__label, .lnk-form-dialog .el-radio__label {
        font-size: 12px;
    }

    /*组件里form表单中调试的样式*/
    .lnk-form-dialog .el-form-item__label {
        line-height: 28px;
        font-size: 12px;
        font-weight: bold;
        /*margin-right: 20px;*/
        width: 120px;
    }

    .lnk-form-dialog .el-form-item {
        margin-bottom: 14px;
    }

    .lnk-form-dialog .el-form-item__error {
        display: none;
        padding-top: 0;
    }

    .lnk-form-dialog .el-form-item__content {
        line-height: 28px;
        float: left;
    }

    .lnk-form-dialog .el-dialog__footer {
        text-align: center;
    }

    /*组件在dms/crm中样式差异*/
    .lnk-form-dialog .crm-color .el-button--text {
        color: #1F74FF;
    }

    .lnk-form-dialog .crm-color .el-button--primary {
        background-color: #1F74FF;
        border-color: #1F74FF;
    }

    .lnk-form-dialog .crm-color .el-button--default:hover {
        color: #1F74FF;
        background-color: transparent;
        border-color: #1F74FF;
    }
</style>
